import React from "react"
export const CardContainer = ({ children }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-x-6 gap-y-12 mb-20 pb-20">
      {children}
    </div>
  )
}

type Sizes = "s" | "m" | "l" | "none"
type Colors = "blue" | "white" | "gray"

type Props = {
  children: React.ReactNode
  className?: string
  margin?: Sizes
  shadow?: Sizes
  rounded?: Sizes
  color?: Colors
  icon?: JSX.Element
}

type SizeDict = Record<Sizes, string>

export const Card = ({
  children,
  margin = "m",
  rounded = "m",
  shadow = "m",
  color = "white",
  icon,
}: Props) => {
  const marginClass: SizeDict = {
    s: "p-2 ",
    m: "p-9",
    l: "p-9 sm:px-16 sm:py-14",
    none: "",
  }

  const roundedClass: SizeDict = {
    s: "rounded-xl",
    m: "rounded-2xl",
    l: "rounded-3xl",
    none: "",
  }

  const shadowClass: SizeDict = {
    s: "shadow-md",
    m: "shadow-xl",
    l: "shadow-2xl",
    none: "",
  }

  const colorClass: Record<Colors, string> = {
    white: "bg-white",
    blue: "bg-blue-500",
    gray: "bg-gray-50",
  }

  const classes = [
    "static",
    "h-full",
    marginClass[margin],
    roundedClass[rounded],
    shadowClass[shadow],
    colorClass[color],
  ].join(" ")

  return (
    <div className={`relative ${icon ? "mt-10" : ""}`}>
      {icon && (
        <div className="absolute w-20 h-20 ml-9 -top-10 flex justify-center items-center rounded-2xl shadow-lg bg-white">
          {icon}
        </div>
      )}
      <div className={classes}>{children}</div>
    </div>
  )
}
